module.exports = __webpack_public_path__ + "static/img/11.1926727.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/11.png
// module id = sXrI
// module chunks = 0